import React from 'react';
import { Button } from './ui/button';
import { heroData } from '../data/mock';
import { ArrowRight, Download } from 'lucide-react';

export const Hero = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-teal-50 via-emerald-50 to-cyan-100">
      {/* Decorative background elements */}
      <div className="absolute inset-0 z-0">
        <div className="absolute top-0 right-0 w-96 h-96 bg-teal-200/40 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-emerald-200/40 rounded-full blur-3xl"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-cyan-200/30 rounded-full blur-3xl"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-6 py-20">
        <div className="max-w-4xl mx-auto text-center">
          {/* Logo */}
          <div className="mb-8 flex justify-center">
            <img 
              src="https://customer-assets.emergentagent.com/job_8f3822bc-92b7-49eb-9b5e-cbe543e4f048/artifacts/81nmknlf_Fuzz_App_Logo.png"
              alt="Fuzz Logo"
              className="h-40 w-auto"
            />
          </div>

          {/* Tagline */}
          <h1 className="text-5xl md:text-7xl font-bold text-gray-900 mb-6 leading-tight">
            {heroData.tagline}
          </h1>

          {/* Subtitle */}
          <p className="text-xl md:text-2xl text-gray-700 mb-12 max-w-2xl mx-auto leading-relaxed">
            {heroData.subtitle}
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            {/* <Button 
              asChild
              size="lg" 
              className="bg-teal-600 hover:bg-teal-500 text-white px-8 py-6 text-lg font-semibold rounded-full transition-all hover:scale-105 hover:shadow-xl shadow-lg"
            >
              <a 
                href="https://fuzzapp.io/app" 
                target="_blank" 
                rel="noopener noreferrer"
              >
                Get Early Access
                <ArrowRight className="ml-2 h-5 w-5" />
              </a>
            </Button> */}

            <Button 
              asChild
              size="lg" 
              variant="outline"
              className="border-2 border-teal-600 text-teal-700 hover:bg-teal-600 hover:text-white px-8 py-6 text-lg font-semibold rounded-full transition-all hover:scale-105 shadow-md"
            >
              <a 
                href="https://fuzzapp.io/app" 
                target="_blank" 
                rel="noopener noreferrer"
              >
                <Download className="mr-2 h-5 w-5" />
                Download App
              </a>
            </Button>
          </div>

          {/* App Preview */}
          <div className="mt-16 flex justify-center gap-4">
            <img 
              src="https://customer-assets.emergentagent.com/job_8f3822bc-92b7-49eb-9b5e-cbe543e4f048/artifacts/a9bs4ttt_Screenshot%202026-02-19%20at%2011.35.52%E2%80%AFAM.png"
              alt="Fuzz App Preview"
              className="h-96 w-auto rounded-3xl shadow-2xl transform hover:scale-105 transition-transform duration-300"
            />
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-teal-600 rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-3 bg-teal-600 rounded-full"></div>
        </div>
      </div>
    </section>
  );
};
